export default "__VITE_ASSET__DG87EPDA__"